module.exports = __webpack_public_path__ + "static/media/programming-svgrepo-com (4).495ae348.svg";